<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div ref="wyGenaricTable" class="wy-genaric-table" :class="tableClass">
    <div class="wy-table-wrapper" style="width: 100%; overflow-x: hidden;">
      <div>
        <!-- Main columns table -->
        <table border="0" class="wy-table-main">
          <thead>          
            <tr ref="wyHeaderMain" class="wy-header" :style="{'left': scrollLeft + 'px'}">
              <th v-for="(group, index) in groupColumns" :key="index" :colspan="group.headerSpan" 
                  v-bind:style="{'min-width': (group.fixed?variableColWidth:group.headerWith)+'px', 'text-align': group.align}">
                <span v-if="group.type!='index' && group.type!='selection' && group.name !== 'target' && group.name !== 'total' && group.name !== 'trend'">{{group.label}}</span>
                <span v-else-if="group.type!='index' && group.type!='selection' && tableData && tableData.length > 0 && iShowTable" >{{group.label}}</span>
              </th>
              <th class="wy-table-tail"><br></th>
            </tr>
            <tr v-if="hasSubtitle" ref="wySubheaderMain" class="wy-sub-header" :style="{'left': scrollLeft + 'px'}">
              <th v-for="(column, index) in allColumns" :key="index" 
                  v-bind:class="{'lastChild': column.lastChild, 'sortable': column.sortable, 'sorted': sortedColumnName==column.sortBy,'ascending': sortedType^sortCaretHovered==0, 'descending': sortedType^sortCaretHovered==1}" 
                  v-bind:style="{'min-width': (column.fixed?variableColWidth:column.minWidth)+'px'}">
                <span v-if="column.type!='index'">{{column.label}}</span>
              </th>
              <th class="wy-table-tail"><br></th>
            </tr>        
          </thead>
          <tbody ref="wyTableBodyMain" class="wy-body">
            <div v-bind:style="{'height': '225px !important'}" class="no-result-found">
              <div class="no-data"></div>
              <div class="no-data-title">{{$t('noResultFound.title')}}</div>
              <div class="no-data-content">
                <div class="content-text">
                  {{$t('noResultFound.message')}}
                </div>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>

    <el-tooltip
      ref="tableTooltip"
      placement="bottom"
      effect="dark"
      :content="tableTooltipContent">
    </el-tooltip>

    <el-popover
      ref="tablePopover"
      placement="bottom"
      title=""
      trigger="hover"      
      popper-class="wy-table-change-popover"
      :content="tablePopoverContent">
    </el-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'wy-genaric-table',
  props: ['controller', 'enableSelection', 'rowClickEvent', 'defaultSort','hasSubtitle', 'tableColumns', 'tableDataResults', 'mode', 'tableName', 'noDataMsg', 'tableBodyHeight'],
  
  data() {
    return {
      module: this,
      iShowTable: false,
      groupColumns: null,
      groupFixedColumns: null,
      sortedColumnName: null,
      sortedType: 1,
      sortCaretHovered: 0,
      tablePopoverContent: null,
      tableTooltipContent: null,
      scrollLeft: 0,
      allColsWidth: -1,
      variableColWidth: 350,
      minWidth: 300,

      targetType: '',
      tableClass: ''
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'companyConfig']),

    fixedColumns() {
      return this.allColumns.filter((item) => item.fixed)
    },

    allColumns() {
      let list = [];
      this.groupColumns.forEach(group => {
        let currGroup = group.columns.filter(el => el.selected);
        for (let i = 0; i < currGroup.length-1; i ++)
          currGroup[i].lastChild = false;
        if (currGroup.length)
          currGroup[currGroup.length-1].lastChild = true;
        list = list.concat(currGroup);
      })
      return list;
    },

    tableData() {
      let list = null;
      let tableResults = [];
      if(this.mode && this.mode == 'generic') {
        tableResults = this.tableDataResults;
      }
      else {
        tableResults = this.tableModel.results;
      } 
      if(this.dataModel.keyword && this.dataModel.keyword!='') {
        let keywordList = this.dataModel.keyword.split(',').map(item => {
          return item.trim();
        });
        list = tableResults.filter(item => new RegExp(keywordList.join("|")).test(item.topicDisplayName))
      }
      else {
        list = tableResults;
      }
      return list;
    }
  },

  methods: {
    refreshTable() {
      // preapare selected columns
      // this.handleSort({sortBy: this.defaultSort.name, sortType: this.defaultSort.type});
      
      let groupMap = {};
      let tableColumns1 = [];
      // if(this.dataModel.columns && this.dataModel.columns.length > 0) {
      if(this.mode && this.mode == 'generic') {
        tableColumns1 = this.tableColumns;
      }
      else {
        tableColumns1 = this.dataModel.columns;
      }
      tableColumns1/*.filter(el => !el.parent)*/.forEach(column => {
        column.sortBy = column.sortBy || column.name;
        column.selected = true;   //default selected all columns
        if(column.groupHidden) {
          if(column.selected) {
            groupMap[column.group] = column;
          }
        }
        else {
          if(!groupMap[column.group]) {
            groupMap[column.group] = {
              label: column.group,
              name: column.group.replace(' ', '-').toLowerCase(),
              columns: [],
              type: column.type,
              isIndeterminate: false,
              fixed: column.fixed,
              width: column.minWidth,
              hasIcon: column.hasIcon,
              cssClass: column.cssClass,
              align: column.align,
              checked: false
            };
          }

          if(column.selected) {
            groupMap[column.group].columns.push(column);
            // // add children
            // if(!column.parent) {
            //   this.dataModel.columns.filter(el => el.parent==column.name).forEach(childColumn => {
            //     groupMap[column.group].columns.push(childColumn);
            //   });
            // }
          }
        }        
      });
      let groupList = [];
      let groupFixedList = [];
      Object.keys(groupMap).forEach(key => {
        let group = groupMap[key];
        if((group.columns == undefined || group.columns.length > 0) && group.name!='dynamicfields') {
          // prepare selected colum list
          groupList.push(group);
          
          // calculate the header width and column spans
          group.headerWith = group.columns.reduce((total, item, index) => {total+=item.minWidth+(index>0?20:0); return total;}, 0);
          group.headerSpan = group.columns.filter(el => el.selected).length;
          
          // prepare fixed column list
          let fixedColumns = group.columns.filter((item) => item.fixed);
          if(fixedColumns.length > 0) {
            groupFixedList.push(group)
          }
        }
      });
      this.allColsWidth = 0;
      for (let i = 0; i < groupList.length; i ++) {
        if (!groupList[i].fixed)
          this.allColsWidth += groupList[i].headerWith + 30;
      }
      // this.variableColWidth will be updated in updated() method

      this.controller.loading = true;
      this.iShowTable = false;
      setTimeout(() => {
        this.controller.loading = false;
        this.groupColumns = groupList;
        this.groupFixedColumns = groupFixedList;
        this.iShowTable = true; 
        this.scrollLeft = 0;
      }, 200);
    }
  },

  created() {
    this.tableClass = this.tableName ? this.tableName + '-table' : '';
  }
}
</script>

<style lang="scss">
.has-indent{
  position: relative;
  left: 20px;
}

.wy-genaric-table {
  width: 100%;

  .wy-table-wrapper {
    position: relative;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    background-color: white;
  }

  table {    
    border-spacing: 0px;
    border-collapse: separate;

    font-size: 14px;
  }

  thead {
    display: table;
    table-layout:fixed;
    background-color: #FFF;
    padding: 0px;

    tr{
      display: block;
      th {
        text-align: left;
        color: #ffffff;
        padding: 9px 10px;
        height: 19px;
        min-height: 19px;
      }
    }

    .wy-header {
      position: relative;
      left: 0px;
      font-size: 15px;
      font-weight: 500;

      th {
        border-right: 1px solid #fff;
        vertical-align: top;
        text-align: center;
      }
    }

    .wy-sub-header {
      position: relative;
      left: 0px;

      th {
        font-size: 13px;
        vertical-align: top;
        text-align: center;
      }
      th.lastChild {
        border-right: 1px solid #fff;
      }
      th.fixed.index label.el-checkbox {
        position: relative;
        bottom: -1px;
      }
      th.sortable::after {  // this reserves space for the up-arrow/down-arrow icon (not shown yet)
        content: "";
        display: inline-block;
        height: 15px;
        width: 15px;
        position: relative;
        top: 4px;
        left: 4px;
        background-repeat: no-repeat;
      }
      th.sortable.sorted.ascending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg') !important;
      }
      th.sortable.sorted.descending::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg') !important;
      }
      th.sortable.sorted.ascending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg') !important;
      }
      th.sortable.sorted.descending:hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg') !important;
      }
      th.sortable:hover {
        background-color: #d1e5fb;
        cursor: pointer;
        color: #003A5D;
        .sort-caret.ascending {
          background-image: url('../../assets/icons/icon_response_perf_sort_ascend.svg') !important;
        }
        .sort-caret.descending {
          background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg') !important;
        }
      }
      th.sortable:not(.sorted):hover::after {
        background-image: url('../../assets/icons/icon_response_perf_sort_descend.svg') !important;
      }
      th:not(.sortable) {
        span {
          padding-left: 0;
        }
      }
    }
  }
  
  tbody {
    display: block;

    tr {
      table-layout: fixed;
      display: block;
      cursor: pointer;

      td {
        padding: 1px 10px;
        height: 60px;
        border-bottom: 1px solid #eee;
        background-color: transparent;

        div {
          display: flex;
          justify-content: center;
        }
      }

      .align-right div {
        margin-left: auto;
        padding-right: 1px;
      }
      .align-right span {
        margin-left: auto;
        padding-right: 1px;
      }

      .wy-table-select .el-checkbox__original {
        margin: 0;
      }

      td.last-child {
        border-right: 1px solid transparent;
        .icon-green-check {
          background-image: url('../../assets/icons/icon-green-check.svg') !important;
          width: 18px;
          background-repeat: no-repeat;
          background-position-y: 3px;
          background-position-x: 0px;
          background-size: 63%;
          
        }
        .icon-red-warning {
          background-image: url('../../assets/icons/icon-red-warning.svg') !important;
          width: 18px;
          background-repeat: no-repeat;
          background-position-y: 2px;
          background-position-x: 6px;
          background-size: 60%;
        }
      }

      td.wy-table-tail {
        padding: 0;
      }
    }
  }

  .highlightedRow td {
    background-color: #f5f7fa !important;
  }

  .wy-table-select {
    min-width: 20px;
    position: relative;
  }

  .wy-table-tail {
    min-width: 22px;
  }
  th.wy-table-tail {
    padding: 9px 7px 9px 10px;
  }

  .wy-table-main {
    width: 100%;
    max-width: 100%;
    thead {
      width: fit-content;
      th {
        background-color: #FFF;
      }
      th:last-child, th:nth-last-child(2) {
        border-right: 1px solid transparent;
      }
      th:last-child, th:nth-last-child(1) {
        border-right: 1px solid transparent;
      }
      tr {
        // float: left;  // THIS PLACE IS WHERE SAFARI MESSED UP WHEN YOU ZOOM OUT THE PAGE (BUT CHROME AND FIREFOX DIDN'T)
        width: calc( 100vw - 400px);
        :first-child {
          padding-left: 18px;  // adding the same amt of padding in fixed table
        }
      }
      .wy-header {
        span {
          padding-left: 5px;
        }
      }
    }
    tbody { 
      height: calc( 100vh - 245px );
      overflow: auto;
      width: 100%;
      max-width: 100%;
      tr {
        // float: left;  // THIS PLACE IS WHERE SAFARI MESSED UP WHEN YOU ZOOM OUT THE PAGE (BUT CHROME AND FIREFOX DIDN'T)
        width: calc( 100vw - 400px );
        td:first-child {
          padding-left: 20px;  // adding the same amt of padding as in fixed table
        }
        td span.positive-change {
          color: #4448A2;
        }
        td span.negative-change {
          color: #3E6891;
        }
        td span.zero-change {
          color: grey;
        }
      }
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }
  }
  // .wy-table-fixed.show-fixed-table-shadow {
  //   // -webkit-box-shadow: 5px -2px 10px -10px grey; */
  //   /* box-shadow: 5px -2px 10px -10px grey; */
  //   box-shadow: 3px 3px 12px #9d9cc759;
  //   background-color: white;
  //   /* border: 1px solid #ddd; */
  //   padding: 0px 6px;
  // }
  .wy-table-fixed {
    position: absolute;
    top: 0px;
    text-align: center;
    // border-left: 1px solid #eee;
    //z-index: 2;
    thead {
      th:nth-last-child(1) {  // corresponding to name colomn in fixed table
        padding-left: 30px;
        text-align: left !important;
      }
    }
    tbody {
      height: calc( 100vh - 270px);
      overflow: auto;
      -ms-overflow-style: none;  // hiding scrollbar on IE
      scrollbar-width: none;     // hiding scrollbar on Firefox
                                 // see below for Chrome
      width: fit-content;
      td:nth-last-child(1) {    // corresponding to name colomn in fixed table
        padding-left: 30px;
        font-weight: 500;
        div {
          justify-content: flex-start;
        }
      }

      tr td:first-child {
        background-color: #F7F8F8;
      }
    }
    tbody::-webkit-scrollbar {    // hiding scrollbar on Chrome
      display: none;
    }
    input {
      margin: 3px;
    }
  }

  .el-no-data {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_comparison_data_not_available.svg') !important;
    background-size: 75%;
    background-repeat: no-repeat;
    background-position-y: 2px;
    background-position-x: 1px;
    background-color: transparent !important;
    height: 20px;
    width: 20px;
    border: 0px;
    margin-left: 0px;
  }

  .el-no-data:hover {
    background-color: unset;
  }

  .icon-number {
    background-color: #80a6cd;
    border-radius: 10px;
    border: 1px solid #FFF;
    height: 16px;
    width: 16px;
    position: relative;
    top: -10px;
    left: 8px;
    font-size: 9px;
    padding-top: 1px;
    padding-left: 0px;
    line-height: initial;
    color: #FFF;
    text-align: center;
  }

  .small-font {
    font-size: 6px !important;
    padding-top: 3px !important;
  }

  .wy-table-icon {
    display: inline-block;
    width : 25px;
    height: 25px;
    background-repeat: no-repeat;
    background-size: 55%;
    position: relative;
    top: 10px;
  }

  .wy-table-change-popover.el-popover--plain {
      padding: 8px 10px;
      border-radius: 5px;
      background-color: var(--site-font-chart-color);
      color: #FFF;
      font-size: 12px;
    .popper__arrow {
      filter: invert(1);
    }
  }

  .wy-table-alert-popover.el-popover--plain {
    background: #80A6CD;
    color: #FFF;
    border-radius: 10px;
    padding: 5px 10px;
    display: inline-block;
    .popper__arrow {
      display: none;
    }
  }
  .no-result-found {
    overflow: hidden;
    .no-data {
      height: 100px;
      margin-top: 20px;
      background-size: 95px;
    }
    .no-data-title {
      margin-top: 0px;
    }
  }
}
@media screen and (min-width: 1600px) {
  .wy-genaric-table {
    .no-result-found {
      overflow: hidden;
      .no-data {
        // height: 100px;
        // margin-top: 20px;
        // background-size: 10%;
      }
      .no-data-title {
        // margin-top: 0px;
      }
    }
  }
}
</style>